import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";

type ArrayData = Array<Entidad.ICovidEncuesta>;

interface IRespose {
    Datos: ArrayData;
    Resultado: number;
}

export function _SvCovidObtenerListaEncuesta(idEscuela: number): Promise<DataDRequest.IResultadoPeticion<ArrayData>> {
    const url = _APP_CONFIG.URL_RSTV2 + "covid/ObtenerListaEncuesta";
    const params = {
        IdEscuela: idEscuela
    }
    return new Promise(async (resolve, reject) => {
        await DataDRequest._Request2<IRespose>(url, "GET", params)
            .then(res => {
                resolve({
                    Resultado: (res.error ? -1 : res.data.Resultado),
                    Data: (res.error ? null : res.data.Datos)
                })
            })
    })
}
